import { useEffect } from "react";
import { useYbugApi } from "ybug-react";

export function useCardPageScriptGuard() {
    const ybugCtx = useYbugApi();

    useEffect(() => {
        const ybug = ybugCtx?.Ybug;
        if (!ybug) return undefined;

        ybug.destroy();
        return () => {
            ybug.boot();
        };
    }, [ybugCtx?.Ybug]);
}
